var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lr-preview-comp",staticStyle:{"height":"calc(100% - 20px)","position":"relative"}},[_c('div',{style:(_vm.getPreviewStyles())},[_c('Render',{attrs:{"widget":_vm.widget}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }